var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Search } from './search.js';
export class CommunityRecovery extends Search {
    constructor(request, didGraphQL, referralConfig) {
        super(request);
        this._didGraphQL = didGraphQL;
        this.referralConfig = referralConfig;
    }
    getPhoneCountryCodeWithLocal() {
        return __awaiter(this, void 0, void 0, function* () {
            return this._request.send({
                method: 'GET',
                url: '/api/app/phone/info',
            });
        });
    }
    checkGoogleRecaptcha(params) {
        return this._request.send({
            method: 'POST',
            url: '/api/app/account/isGoogleRecaptchaOpen',
            params,
        });
    }
    getHolderInfo(params) {
        return this._request.send({
            method: 'GET',
            url: '/api/app/account/guardianIdentifiers',
            params,
        });
    }
    getRegisterInfo(params) {
        return this._request.send({
            method: 'GET',
            url: '/api/app/account/registerInfo',
            params,
        });
    }
    getVerificationCode(requestParams) {
        return this._request.send(Object.assign({ method: 'POST', url: '/api/app/account/sendVerificationRequest' }, requestParams));
    }
    verifyVerificationCode(params) {
        return this._request.send({
            method: 'POST',
            url: '/api/app/account/verifyCode',
            params,
        });
    }
    register(params) {
        const _params = Object.assign({}, params);
        if (this.referralConfig.referralInfo)
            _params.referralInfo = this.referralConfig.referralInfo;
        return this._request.send({
            method: 'POST',
            url: '/api/app/account/register/request',
            params: _params,
        });
    }
    recovery(params) {
        const _params = Object.assign({}, params);
        if (this.referralConfig.referralInfo)
            _params.referralInfo = this.referralConfig.referralInfo;
        return this._request.send({
            method: 'POST',
            url: '/api/app/account/recovery/request',
            params: _params,
        });
    }
    getHolderInfoByManager(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this._didGraphQL.getHolderInfoByManager(params);
            return result.caHolderManagerInfo;
        });
    }
    /**
     * deprecated Please use `verification.sendAppleUserExtraInfo`
     */
    sendAppleUserExtraInfo(params) {
        return this._request.send({
            method: 'POST',
            url: '/api/app/userExtraInfo/appleUserExtraInfo',
            params,
        });
    }
    verifyZKLogin(params) {
        return this._request.send({
            method: 'POST',
            url: '/api/app/account/verifiedzk',
            params,
        });
    }
    /**
     * deprecated Please use `verification.getAppleUserExtraInfo`
     */
    getAppleUserExtraInfo(params) {
        return this._request.send({
            method: 'GET',
            url: `/api/app/userExtraInfo/${params.userId}`,
        });
    }
    /**
     * deprecated Please use `verification.verifyGoogleToken`
     */
    verifyGoogleToken(params) {
        return this._request.send({
            method: 'POST',
            url: '/api/app/account/verifyGoogleToken',
            params,
        });
    }
    /**
     * deprecated Please use `verification.verifyAppleToken`
     */
    verifyAppleToken(params) {
        return this._request.send({
            method: 'POST',
            url: '/api/app/account/verifyAppleToken',
            params: Object.assign(Object.assign({}, params), { accessToken: params.identityToken }),
        });
    }
    /**
     * deprecated Please use `verification.verifyTelegramToken`
     */
    verifyTelegramToken(params) {
        return this._request.send({
            method: 'POST',
            url: '/api/app/account/verifyTelegramToken',
            params,
        });
    }
    /**
     * deprecated Please use `verification.verifyTwitterToken`
     */
    verifyTwitterToken(params, headers) {
        return this._request.send({
            method: 'POST',
            url: '/api/app/account/verifyTwitterToken',
            params,
            headers,
        });
    }
    /**
     * deprecated Please use `verification.verifyFacebookToken`
     */
    verifyFacebookToken(params) {
        return this._request.send({
            method: 'POST',
            url: '/api/app/account/verifyFacebookToken',
            params,
        });
    }
    /**
     * deprecated Please use `verification.getRecommendationVerifier`
     */
    getRecommendationVerifier(params) {
        return this._request.send({
            method: 'POST',
            url: '/api/app/account/getVerifierServer',
            params,
        });
    }
    /**
     * deprecated Please use `verification.getTelegramAuthToken`
     */
    getTelegramAuthToken(params) {
        return this._request.send({
            method: 'GET',
            url: '/api/app/telegramAuth/token',
            params,
        });
    }
    getShowDeletionEntrance() {
        return this._request.send({
            method: 'GET',
            url: '/api/app/account/revoke/entrance',
        });
    }
    checkDeletion() {
        return this._request.send({
            method: 'GET',
            url: '/api/app/account/revoke/check',
        });
    }
    deletionAccount(params) {
        return this._request.send({
            method: 'POST',
            url: '/api/app/account/revoke/request',
            params,
        });
    }
}
